import api from 'api';
import storage from "@/cflow/storageService";

class DentistaExternoService {

    listar(dados, skiped) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/dentista-externo?skiped='+skiped+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/dentista-externo?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/dentista-externo/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvar(id, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/dentista-externo/' + id + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.delete('/dentista-externo/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new DentistaExternoService();